// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayEditor_container__1igfH","actions":"DisplayEditor_actions__2Fw0b","disabled":"DisplayEditor_disabled__wvsu_"};